import { z } from "@/zod";
import { NIP_REGEXP } from "@/constants";
import { t } from "i18next";
import { validateNIPChecksum } from "./taxIdentificationNumberValidation";

export const taxIdentificationNumber = z
  .string()
  .min(10, t("validation.tax_identification_number.too_short"))
  .max(13, t("validation.tax_identification_number.too_long"))
  .regex(NIP_REGEXP, t("validation.tax_identification_number.invalid_format"))
  .refine((val) => validateNIPChecksum(val), {
    message: t("validation.tax_identification_number.checksum_failed"),
  });
